import React from 'react';
import { Link } from 'react-router-dom';
import { Heart } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="border-t border-pink-100/60 bg-gradient-to-b from-white to-pink-50/30 mt-auto">
      <div className="container mx-auto px-4 md:px-8 max-w-7xl py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="md:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <Heart className="h-5 w-5 text-primary" strokeWidth={1.5} fill="currentColor" />
              <span className="font-script text-2xl" style={{color: 'hsl(340, 30%, 25%)'}}>Dior Russell</span>
            </Link>
            <p className="text-sm text-muted-foreground leading-relaxed">
              Official bookstore of author Dior Russell. Discover captivating stories and transformative reads.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-accent text-xs uppercase tracking-[0.2em] text-primary/70 mb-4">Browse</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/browse" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  All Books
                </Link>
              </li>
              <li>
                <Link to="/browse?featured=true" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Featured
                </Link>
              </li>
              <li>
                <Link to="/browse?new_release=true" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  New Releases
                </Link>
              </li>
            </ul>
          </div>

          {/* Account */}
          <div>
            <h4 className="font-accent text-xs uppercase tracking-[0.2em] text-primary/70 mb-4">Account</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/dashboard" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Dashboard
                </Link>
              </li>
              <li>
                <Link to="/orders" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Orders
                </Link>
              </li>
              <li>
                <Link to="/library" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  My Library
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-accent text-xs uppercase tracking-[0.2em] text-primary/70 mb-4">Contact</h4>
            <ul className="space-y-2.5">
              <li className="text-sm text-muted-foreground">
                contact@diorrussell.com
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-pink-100/60 mt-8 pt-8 text-center">
          <p className="text-xs text-muted-foreground">
            &copy; {new Date().getFullYear()} Dior Russell Books. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};
